import React from 'react';
import { connect } from 'react-redux';

import {
  getTotalSavingsForLineItems,
  getLineItemsSubscribable,
  getLineItemsRegular,
  getTotalPriceOfLineItems,
  getLineItemsSubscribableQuantity,
} from '../selectors';
import LineItems from '../components/sidebar/LineItems';

const mapStateToProps = state => {
  const lineItemsSubscribable = getLineItemsSubscribable(state);
  return {
    lineItemsSubscribable,
    lineItemsRegular: getLineItemsRegular(state),
    currentOrder: state.currentOrder,
    isMembershipOrder: state.currentOrder.membership_order,
    subscribableCostOrig:
      getTotalPriceOfLineItems(lineItemsSubscribable, state) +
      getTotalSavingsForLineItems(lineItemsSubscribable, state),
    subscribableCostNew: getTotalPriceOfLineItems(lineItemsSubscribable, state),
    subscribableQuantity: getLineItemsSubscribableQuantity(state),
    subscribableVariantDiscountRate: state.subscribableVariantDiscountRate,
  };
};

export default connect(mapStateToProps)(LineItems);



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/containers/LineItems.js